<template>
  <div>
    <div v-if="!isLoggedIn">
      <LoginPage @login-success="handleLoginSuccess" />
    </div>
    <div v-else>
      <!-- Main Content -->
      <div class="top-bar">
        <div class="image-container">
          <div class="left">
            <img alt="Bewo logo" src="./assets/img/Logo wit.png" style="width: 200px; height: auto;">
          </div>
          <div class="center">
            <span class="Eurostile-text">Cutting Wizard</span>
          </div>
          <div class="right">
            <span class="getshow-text">We take care</span>
          </div>
        </div>
      <FormComponent msg="invoervelden" />
    </div>
    <div v-if="isSuperAdmin">
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import LineChart from './components/LineChart.vue';
import LoginPage from './components/LoginPage.vue'
import FormComponent from './components/FormComponent.vue'
import UserManagement from './components/UserManagement.vue';
import Parentcomponent from './components/Parentcomponent.vue';

export default {
  name: 'App',
  components: {
    LoginPage,
    FormComponent,
    UserManagement,
    Parentcomponent,
    LineChart
  },
  data() {
    return {
      isLoggedIn: false,
      isSuperAdmin: false, // Added isSuperAdmin flag
    };
  },
  methods: {
    handleLoginSuccess(user) {
      console.log('User logged in:', user);
      this.isLoggedIn = true;
      if ( user.userName === 'goof.vannunen@bewocs.com'||
      user.userName === 'tony.nelemans@bewocs.com'|| user.userName ==='maarten.vanheuven@bewocs.com' || 'sander.stadelman@bewocs.com') {
        this.isSuperAdmin = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/main';

.image-container {
  display: flex;
  justify-content: space-between; /* Adjust this as needed */
  flex-wrap: wrap; /* Allow the container to wrap elements */
  background-color: #4b4b4b; /* Replace 'grey' with the shade of grey you want, e.g., #ccc */
}

@font-face {
  font-family: 'Getshow';
  src: local('Getshow'), url('@/assets/fonts/Get Show.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Eurostile';
  src: local('Eurostile'), url('@/assets/fonts/Eurostile.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
.getshow-text {
  font-family: 'Getshow', sans-serif;
  font-size: 50px;
  color: #ffffff
  /* Add any additional styles you need here */
}
.Eurostile-text {
  font-family: 'Eurostile', sans-serif;
  font-size: 30px;
  color: #ffffff
  /* Add any additional styles you need here */
}

.left,
.center,
.right {
  width: 30%; /* Equal width for each section, adjust the percentage as needed */
  text-align: center; /* Center-align the images within each section */
  padding: 5px; /* Add padding to prevent images from touching */
}

@media (max-width: 1000px) {
  .center .Eurostile-text
   {
    display: none;
  }
}
@media (max-width: 600px) {
  .right .getshow-text
   {
    display: none;
  }
}
</style>
